import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import type {ValueSockets} from "#material/nodes/input/value/definition"
import {valueDefinition} from "#material/nodes/input/value/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeConvert, threeValue} from "#material/three/three-utils"
import {registerMaterialGraphNode} from "#material/register"
import type {ThreeReturns} from "#material/sockets/three"
import type {ValueNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class Value extends MaterialNode<ValueSockets> {
    public override get definition() {
        return valueDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<ValueSockets>> => {
        const value = threeConvert(this.parameters.settings.value, threeValue) ?? threeValue(0)
        return {value}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<ValueSockets>> => {
        const {parameters} = this
        const {inputs} = parameters

        const valueNode: ValueNode = {
            type: "value",
            inputs: {},
            parameters: {
                value: parameters.settings.value,
            },
            resources: {},
        }

        return {value: [valueNode, "value"]}
    }
}
